<template>
  <div>Loading...</div>
</template>

<script>
export default {
  name: 'dummy-home',

  created() {
    console.log('dummy home', this.$route);
  },
};
</script>

<style scoped></style>
